module.exports = __webpack_public_path__ + "components/country-flag/static/cm-b09bb372e446f5ca1accd57750226793.svg";